// extracted by mini-css-extract-plugin
module.exports = {"row":"EditTasksLists_row__RCg2u","cell":"EditTasksLists_cell__3uYzh","actions":"EditTasksLists_actions__BJmVk","input":"EditTasksLists_input__2ilw3"};